export default __webpack_public_path__ + "static/media/ico_warning_yellow.44bdbf94.svg";